module.exports = __webpack_public_path__ + "static/media/0221_Medium.90ef9bc7.jpg";